// extracted by mini-css-extract-plugin
export default {"grid":"documentsGrid_grid__+mVuX","buttonClass":"documentsGrid_buttonClass__FUNYX","titleSection":"documentsGrid_titleSection__-sEBE"};